import { render } from "./ActivityLog.vue?vue&type=template&id=cd475b7a"
import script from "./ActivityLog.vue?vue&type=script&lang=js"
export * from "./ActivityLog.vue?vue&type=script&lang=js"
script.render = render

export default script